export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  countriesDetails: {
    countries: "/countries",
    VisaTypeDetails: "/countries/:id/VisaTypeDetails",
    VisaTypeDetailsNationality: "/countries/:id/VisaTypeDetails/nationality",
    countriesGallery: "/countries/:id/gallery",
    countriesPrices: "/countries/:visa_type_id/prices/:id",
    groups: "/groups",
    groupsPrices: "/groups/:visa_type_id/prices/:id",
    questionnaires: "/questionnaires",
    QuestionsCategory: "/questions_category",
    questionnairesByCategory: "/questions_category/:id/questionnaires",
    documents: "/documents",
    nationality: "/nationality",
    visaType: "/visa-type",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  admins_logs: {
    admins_logs: "/admins-logs",
  },
  ListDocuments: "/ListDocuments/:from/:id", // from = group / country
  ListQuestions: "/ListQuestions/:from/:id",
  ListQuestionsDocuments: "/ListQuestionsDocuments",
  trustedBy: "/trusted-by",
  testimonials: "/testimonials",
  clients: "/clients",
  working_process: "/working-process",
  stats: "/stats",
  services: "/services",
  contact: "/contact",
  settings: {
    settings: "/settings",
    legal_information: "/legal_information",
  },
  request_reviews: "/request-reviews/:country_id",
  requests: "/requests",
  request: "/request/:id",
  support: "/support",
  home: "/dashboards/ecommerce",
  awards: "/countries/:id/awards",
  userSessions: "/user-ai-chat-sessions/:userId",
  slideshow: "/slidershow",
  projects: "/projects",
  media: "/media/:type/:related_id",
  ourTeam: "/our-team",
  qualityTable: "/quality-table",
  companies: "/companies",
};
